module.exports = __webpack_public_path__ + "static/img/stripe.1165fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stripe.png
// module id = LxHi
// module chunks = 3